import { Notification } from './NotificationsPopover';

export const notifications: Notification[] = [];
